
 <div class="px-4 sm:px-8 lg:px-[74px] py-6 sm:py-10">
  <form #mergeImageForm="ngForm">
  <h2 class="text-2xl sm:text-3xl text-gray-900 text-center font-bold mb-6">Merge Images</h2>


  <div class="flex mb-6">
    <div class="w-[800px] max-w-full mx-auto">

        <div class="upload-box" (drop)="onDrop($event)" (dragover)="allowDrop($event)" (dragenter)="allowDrop($event)" (click)="fileInput.click()">
          <span>
            <img src="../../../../../../../assets/theme/images/icons/photo-plus.svg"  alt="photo-plus"
            class="w-6 h-6 cursor-pointer" />
          </span>
          <p>
            Click to Add or Drag & Drop Images</p>
          <input
          #fileInput
          type="file"
          accept="image/*"
          class="hidden"
          required
          multiple
          (change)="onSelect($event)"/>
        </div>
        @if(fileError){
          <span class="text-danger">{{fileError}}</span>
        }

    </div>
  </div>

  <div class="mx-auto">



    <div class="flex flex-col lg:flex-row items-center lg:items-start justify-center gap-4 w-full lg:w-[800px] max-w-full mx-auto">

      <div class="w-full lg:w-auto lg:flex-1 lg:min-w-0 min-h-[420px] shrink-0 border border-gray-200 shadow-sm p-4 rounded-2xl bg-white bg-nav-tabs">
        <ul class="flex flex-nowrap items-center text-nowrap cursor-pointer mb-2 list-none p-0 m-0 overflow-x-auto">
          <li class="nav-item">
              <a class="nav-link inline-block px-4 py-2 text-sm"
                  [ngClass]="{'active': activeTab === 'Original'}"
                  (click)="setTab('Original')">
                  See Images
              </a>
          </li>
          <li class="nav-item ms-2">
              <a class="nav-link inline-block px-4 py-2 text-sm"
                  [ngClass]="{'active': activeTab === 'Merge-Images'}" (click)="setTab('Merge-Images')">
                  Merged Image
              </a>
          </li>
          @if (mergeImageResquestModel.images.length) {
            <div class="ms-auto mt-2">
              <span>
                <img (click)="clear()" src="../../../../../../../assets/images/reset.svg" title="reset" alt="reset" height="18" width="18"
                  class="w-6 h-6 cursor-pointer" />
              </span>
            </div>
          }
      </ul>




      @if(activeTab === 'Original') {
        @if(!mergeImageResquestModel.images.length){
          <div class="image-preview1">
            <p>No images added yet</p>
          </div>
          }
        <div class="preview-row">
          @for (image of images; track $index; let i = $index) {
            <div  class="small-image-box">
              <img [src]="image" class="small-image" />
              <button class="tiny-remove-btn" (click)="removeImage(i)" title="Remove">
                ✕
              </button>
            </div>
          }
        </div>
      }
          @else {
            @if(isLoading) {
              <div class="h-[400px] w-full bg-gray-400 rounded animate-pulse"></div>
             }
             @else if(!mergeImageResquestModel.images.length){
              <div class="image-preview1">
                <p>No images added yet</p>
              </div>
              }
             @else if( this.mergeImageResponseModel.base64_image){
              <div class="image-preview1">
                <img tabindex="0" (click)="preview()" src="./assets/theme/images/icons/Eye-password-Black.svg" alt="Eye-password-Black" class="eye-icon" />
                <img [src]="getImageSource" alt="Removed Background" />
              </div>
             }

          }



      </div>

      <div class="w-full lg:w-80 shrink-0 border border-gray-200 shadow-sm p-4 rounded-2xl bg-white">
        <div class="mb-1">
          <label for="direction" class="block mb-1 text-sm font-medium">Direction</label>
          <ng-select #imageResolution="ngModel" clearable="false"
            class="border border-[#E3E6EE] rounded shadow-none text-sm leading-6 font-medium text-[#15191E] focus:shadow-none" name="direction" required
            [(ngModel)]="mergeImageResquestModel.orientation">
            <ng-option [value]="directionEnum.Horizontal">Horizontally</ng-option>
            <ng-option [value]="directionEnum.Vertical">Vertically</ng-option>
          </ng-select>
        </div>
        <div class="mb-1">
          <button  (click)="mergeImages()" [disabled]="!mergeImageForm.valid || !mergeImageResquestModel.images.length"
            class="flex items-center justify-center py-3 w-full rounded-full text-base leading-5
             text-white font-medium bg-black">
             Merge Images
            @if(isLoading){
            <span
              class="border-white h-4 w-4 animate-spin rounded-full border-2 border-t-white ms-2"></span>
            }
          </button>
        </div>
        @if (mergeImageResponseModel.base64_image) {
          <button type="submit" (click)="downloadImage()" [disabled]="!mergeImageForm.valid"
            class="flex items-center justify-center py-3 w-full rounded-full text-base leading-5
             text-white font-medium bg-black">
             Download Image
            @if(isDownloading){
            <span
              class="border-white h-4 w-4 animate-spin rounded-full border-2 border-t-white ms-2"></span>
            }
          </button>
        }
      </div>
    </div>

  </div>


</form>
</div>
